// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/AG-Book-Stencil-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/SuisseIntl-Light-WebS.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/SuisseIntl-Regular-WebS.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/SuisseIntl-Medium-WebS.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/SuisseIntl-SemiBold-WebS.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/SuisseIntl-Bold-WebS.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'ag-book-stencil-regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  /* Additional font properties */
}

@font-face {
  font-family: 'suisse-intl-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: 300;
  /* Additional font properties */
}

@font-face {
  font-family: 'suisse-intl-regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  font-weight: 400;
  /* Additional font properties */
}

@font-face {
  font-family: 'suisse-intl-medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
  font-weight: 500;
  /* Additional font properties */
}

@font-face {
  font-family: 'suisse-intl-semibold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');

  /* Additional font properties */
}

@font-face {
  font-family: 'suisse-intl-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
  font-weight: 600;
  /* Additional font properties */
}

body,html{
  font-family: 'suisse-intl-regular';
}
  

h1,h2,h3{
  font-family: 'suisse-intl-semibold';

}

h2, blockquote{
  font-size: 23px;
  line-height: 30px;
}

p{
  font-family: 'suisse-intl-regular';
  font-size:14px;
  line-height: 30px;

}

#legalModal p{
  font-size:12px;
  line-height: 20px;
  margin-bottom: 1rem;
}

footer p{
 
}

b, .button{
  font-family: 'suisse-intl-bold';
}

.activateButton{
  font-size:10px;
  font-family: 'ag-book-stencil-regular';
}

/* Default style for PageExtra (hidden below the screen) */
#buyModal {
  opacity: 0;
  position: fixed;
  bottom: -100%; /* Start it off-screen */
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out; /* Apply smooth animation */
  pointer-events: none;
}

/* Style when it's visible (slid up) */
#buyModal.active {
  opacity: 1;
  bottom: 0;
  pointer-events: auto;

}
#legalModal {
  opacity: 0;
  position: fixed;
  bottom: -100%; /* Start it off-screen */
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out; /* Apply smooth animation */
  pointer-events: none;
}
/* Style when it's visible (slid up) */
#legalModal.active {
  opacity: 1;
  bottom: 0;
  pointer-events: auto;
}

#buyButton{
  height: 45px;
  bottom: 3px;
  z-index:15;
}

.fade-out {
  transition: opacity 1s ease-out;
  opacity: 0;
  pointer-events: none;
}

.flash {
  animation: flashAnimation 0.5s;
}

@keyframes flashAnimation {
  0% { background-color: red; }
  50% { background-color: red; }
  100% { background-color: red; }
}

bg-color-EBFD00 { 
  background-color: #EBFD00;
}

bg-color-F2F2F2 { 
  background-color: #F2F2F2;
}

bg-color-FF7600 { 
  background-color: #FF7600;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,4DAAiE;EACjE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,4DAA+D;EAC/D,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,4DAAiE;EACjE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,4DAAgE;EAChE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4DAAkE;;EAElE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,4DAA8D;EAC9D,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;;AAGA;EACE,mCAAmC;;AAErC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;;AAEnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAW;AACb;;AAEA;;AAEA;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,eAAe;EACf,aAAa,EAAE,wBAAwB;EACvC,OAAO;EACP,QAAQ;EACR,gCAAgC,EAAE,2BAA2B;EAC7D,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;;AAEtB;AACA;EACE,UAAU;EACV,eAAe;EACf,aAAa,EAAE,wBAAwB;EACvC,OAAO;EACP,QAAQ;EACR,gCAAgC,EAAE,2BAA2B;EAC7D,oBAAoB;AACtB;AACA,sCAAsC;AACtC;EACE,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,KAAK,qBAAqB,EAAE;EAC5B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,qBAAqB,EAAE;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@font-face {\n  font-family: 'ag-book-stencil-regular';\n  src: url('./fonts/AG-Book-Stencil-Regular.woff2') format('woff2');\n  /* Additional font properties */\n}\n\n@font-face {\n  font-family: 'suisse-intl-light';\n  src: url('./fonts/SuisseIntl-Light-WebS.woff2') format('woff2');\n  font-weight: 300;\n  /* Additional font properties */\n}\n\n@font-face {\n  font-family: 'suisse-intl-regular';\n  src: url('./fonts/SuisseIntl-Regular-WebS.woff2') format('woff2');\n  font-weight: 400;\n  /* Additional font properties */\n}\n\n@font-face {\n  font-family: 'suisse-intl-medium';\n  src: url('./fonts/SuisseIntl-Medium-WebS.woff2') format('woff2');\n  font-weight: 500;\n  /* Additional font properties */\n}\n\n@font-face {\n  font-family: 'suisse-intl-semibold';\n  src: url('./fonts/SuisseIntl-SemiBold-WebS.woff2') format('woff2');\n\n  /* Additional font properties */\n}\n\n@font-face {\n  font-family: 'suisse-intl-bold';\n  src: url('./fonts/SuisseIntl-Bold-WebS.woff2') format('woff2');\n  font-weight: 600;\n  /* Additional font properties */\n}\n\nbody,html{\n  font-family: 'suisse-intl-regular';\n}\n  \n\nh1,h2,h3{\n  font-family: 'suisse-intl-semibold';\n\n}\n\nh2, blockquote{\n  font-size: 23px;\n  line-height: 30px;\n}\n\np{\n  font-family: 'suisse-intl-regular';\n  font-size:14px;\n  line-height: 30px;\n\n}\n\n#legalModal p{\n  font-size:12px;\n  line-height: 20px;\n  @apply mb-4;\n}\n\nfooter p{\n \n}\n\nb, .button{\n  font-family: 'suisse-intl-bold';\n}\n\n.activateButton{\n  font-size:10px;\n  font-family: 'ag-book-stencil-regular';\n}\n\n/* Default style for PageExtra (hidden below the screen) */\n#buyModal {\n  opacity: 0;\n  position: fixed;\n  bottom: -100%; /* Start it off-screen */\n  left: 0;\n  right: 0;\n  transition: all 0.3s ease-in-out; /* Apply smooth animation */\n  pointer-events: none;\n}\n\n/* Style when it's visible (slid up) */\n#buyModal.active {\n  opacity: 1;\n  bottom: 0;\n  pointer-events: auto;\n\n}\n#legalModal {\n  opacity: 0;\n  position: fixed;\n  bottom: -100%; /* Start it off-screen */\n  left: 0;\n  right: 0;\n  transition: all 0.3s ease-in-out; /* Apply smooth animation */\n  pointer-events: none;\n}\n/* Style when it's visible (slid up) */\n#legalModal.active {\n  opacity: 1;\n  bottom: 0;\n  pointer-events: auto;\n}\n\n#buyButton{\n  height: 45px;\n  bottom: 3px;\n  z-index:15;\n}\n\n.fade-out {\n  transition: opacity 1s ease-out;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.flash {\n  animation: flashAnimation 0.5s;\n}\n\n@keyframes flashAnimation {\n  0% { background-color: red; }\n  50% { background-color: red; }\n  100% { background-color: red; }\n}\n\nbg-color-EBFD00 { \n  background-color: #EBFD00;\n}\n\nbg-color-F2F2F2 { \n  background-color: #F2F2F2;\n}\n\nbg-color-FF7600 { \n  background-color: #FF7600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
